<div id="advanced-deal-details-container" class="tw-max-w-[700px] tw-mx-auto">
    <div class="tw-flex tw-flex-col tw-gap-4 tw-mt-[50px]">
        <app-deal-owner-smart 
            [deal]="deal" 
            [readOnly]="readOnly"
            [advancedDeal]="true">
        </app-deal-owner-smart>
        <app-deal-timeline-smart
              [dealId]="deal.id"
              [dealCreateTimeStamp]="deal.created"
              [dealApplications]="applications"
              [closerId] = "deal.closedBy"
              [closerName]="closerName"
              [advancedDeal]="true"
              >
            </app-deal-timeline-smart>
        <app-deal-details-smart
            [deal]="deal"
            [approvals]="approvals"
            [advancedDeal]="true">
        </app-deal-details-smart>
    </div>
</div>
